import React, { ReactElement } from 'react';
import LazyImage from 'react-lazy-progressive-image';

import ImageSkeleton from '@components/skeletons/ImageSkeleton';

interface ImageProps {
  width: string;
  height: string;
  src: string;
  alt: string;
  placeholder?: string;
}

const Image = ({ width, height, src, alt, placeholder }: ImageProps): ReactElement => {
  return (
    <LazyImage
      placehoder={placeholder}
      src={src}
      visibilitySensorProps={{ partialVisibility: true, offset: { bottom: -100, right: -100 } }}
    >
      {(src, loading) => {
        return loading ? (
          <ImageSkeleton width={width} height={height} />
        ) : (
          <img width={width} src={src} alt={alt} draggable={false} />
        );
      }}
    </LazyImage>
  );
};

export default Image;
